export default function(node = document) {
  const element = node.querySelector("[data-scroll-last-child]");
  if (element && element.children.length) {
    const lastChild = [...element.children].pop();
    window.scrollTo({ top: lastChild.offsetTop, behavior: "smooth" });
  }
}
